import { createUseStyles } from 'react-jss';
import { ITheme, mediaQuery } from '@quicktools/shared-components';

const useStyles = createUseStyles(
  ({ breakpoints }: ITheme) => ({
    root: {
      fontSize: 16,
      lineHeight: '24px',
      marginTop: 6,

      [mediaQuery(breakpoints.tablet)]: {
        fontSize: 14,
        lineHeight: '20px',
      },
    },

    category: {
      color: 'var(--x-text-color-6)',
      fontWeight: 600,
      display: 'inline-block',
      marginRight: 18,

      [mediaQuery(breakpoints.tablet)]: {
        lineHeight: '20px',
        marginRight: 16,
      },
    },

    name: {
      display: 'inline-block',
      color: 'var(--x-text-color-6)',
      fontFeatureSettings: "'kern' off",
      fontWeight: 500,
    },
  }),
  { name: 'FontInfo' },
);

export default useStyles;
